module.exports = __webpack_public_path__ + "img/img1.00c50e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img1.png
// module id = 164
// module chunks = 0